var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M355.8 96H432C476.2 96 512 131.8 512 176V336C512 380.2 476.2 416 432 416H244.2L280.2 384H432C458.5 384 480 362.5 480 336V176C480 149.5 458.5 128 432 128H368C368 116.7 364 105.3 355.9 96.11L355.8 96zM283.8 96L247.8 128H80C53.49 128 32 149.5 32 176V336C32 362.5 53.49 384 80 384H159.1C159.1 395.3 163.1 406.7 172.1 415.9L172.2 416H80C35.82 416 0 380.2 0 336V176C0 131.8 35.82 96 80 96H283.8zM560 192C568.8 192 576 199.2 576 208V304C576 312.8 568.8 320 560 320C551.2 320 544 312.8 544 304V208C544 199.2 551.2 192 560 192zM218.1 240H352C358.6 240 364.6 244.1 366.1 250.3C369.3 256.5 367.6 263.5 362.6 267.1L218.6 395.1C212 401.8 201.9 401.2 196 394.6C190.2 388 190.8 377.9 197.4 372L309.9 271.1H176C169.4 271.1 163.4 267.9 161 261.7C158.7 255.5 160.4 248.5 165.4 244L309.4 116C315.1 110.2 326.1 110.8 331.1 117.4C337.8 123.1 337.2 134.1 330.6 139.1L218.1 240z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryBolt);
export default __webpack_public_path__ + "static/media/battery-bolt.2505d5af15ae23673292f780b664c80b.svg";
export { ForwardRef as ReactComponent };